import React from 'react'
import moment from 'moment';
import './rangeCalendar.css'
import { useState } from 'react';
import PropTypes from "prop-types"

export default function RangeCalendar({ disableRange , onDateRangeSelection}) {
    const [date, setDate] = useState(moment());
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
   
  
    const resetDate = () => {
      setDate(moment());
    };
  
    const changeMonth = (month) => {
      const newDate = moment(date).month(month);
      setDate(newDate);
    };
  
    const changeDate = (selectedDate) => {
        const today = moment().startOf('day');
        const isPastDate = selectedDate.isBefore(today, 'day');
      
        if (isPastDate) {
          return;
        }
      
        if (disableRange || (!startDate && !endDate)) {
         
          setStartDate(moment(selectedDate));
          setEndDate(null);
          onDateRangeSelection(moment(selectedDate), null);
        } else if (startDate && !endDate) {
          
          if (selectedDate.isBefore(startDate, 'day')) {
            setEndDate(startDate);
            setStartDate(moment(selectedDate));
            onDateRangeSelection(moment(selectedDate), startDate); 
          } else {
            setEndDate(moment(selectedDate));
            onDateRangeSelection(startDate, moment(selectedDate)); 
          }
        } else {
          
          setStartDate(moment(selectedDate));
          setEndDate(null);
          onDateRangeSelection(moment(selectedDate), null);
        }
      };
      
      
   


const Heading = ({date, changeMonth, resetDate}) => (
  <nav className="calendar--nav">
    <a onClick={() => changeMonth(date.month() - 1)}>&#8249;</a>
    <h1 onClick={() => resetDate()}>{date.format('MMMM')} <small>{date.format('YYYY')}</small></h1>
    <a onClick={() => changeMonth(date.month() + 1)}>&#8250;</a>
  </nav>
);

const Day = ({currentDate, date, startDate, endDate, onClick}) => {
  let className = [];

  if (moment().isSame(date, 'day')) {
    className.push('active');
  }

  if (date.isSame(startDate, 'day')) {
    className.push('start');
  }

  if (date.isBetween(startDate, endDate, 'day')) {
    className.push('between');
  }

  if (date.isSame(endDate, 'day')) {
    className.push('end');
  }

  if (! date.isSame(currentDate, 'month')) {
    className.push('muted');
  }

  return (
    <span onClick={() => onClick(date)}  className={className.join(' ')}>{date.date()}</span>
  )
};

const Days = ({date, startDate, endDate, onClick}) => {
  const thisDate = moment(date);
  const daysInMonth = moment(date).daysInMonth();
  const firstDayDate = moment(date).startOf('month');
  const previousMonth = moment(date).subtract(1, 'month');
  const previousMonthDays = previousMonth.daysInMonth();
  const nextsMonth = moment(date).add(1, 'month');
  let days = [];
  let labels = [];

  for (let i = 1; i <= 7; i++) {
    labels.push(<span className="label">{moment().day(i).format('ddd')}</span>);
  }

  for (let i = firstDayDate.day(); i > 1; i--) {
    previousMonth.date(previousMonthDays - i + 2);

    days.push(
      <Day key={moment(previousMonth).format('DD MM YYYY')} onClick={(date) => onClick(date)} currentDate={date} date={moment(previousMonth)} startDate={startDate} endDate={endDate} />
    );
  }

  for (let i = 1; i <= daysInMonth; i++) {
    thisDate.date(i);

    days.push(
      <Day key={moment(thisDate).format('DD MM YYYY')} onClick={(date) => onClick(date)} currentDate={date} date={moment(thisDate)} startDate={startDate} endDate={endDate} />
    );
  }

  const daysCount = days.length;
  for (let i = 1; i <= (42 - daysCount); i++) {
    nextsMonth.date(i);
    days.push(
      <Day key={moment(nextsMonth).format('DD MM YYYY')} onClick={(date) => onClick(date)} currentDate={date} date={moment(nextsMonth)} startDate={startDate} endDate={endDate} />
    );
  }

  return (
    <nav className="calendar--days">
      {labels.concat()}
      {days.concat()}
    </nav>
  );
};

  return (
    <div id='range-calendar'>
           <Heading date={date} changeMonth={changeMonth} resetDate={resetDate} />
      <Days onClick={changeDate} date={date} startDate={startDate} endDate={endDate} />
    </div>
  )
}

RangeCalendar.propTypes = {
  disableRange: PropTypes.bool.isRequired,
  onDateRangeSelection: PropTypes.func.isRequired,
  date: PropTypes.shape({
    month: PropTypes.number.isRequired,
    format: PropTypes.string.isRequired,
    isSame: PropTypes.func.isRequired,
    isBetween: PropTypes.func.isRequired,
    date: PropTypes.string.isRequired
  }).isRequired,
  changeMonth: PropTypes.func.isRequired,
  resetDate: PropTypes.func.isRequired,
  currentDate: PropTypes.any.isRequired, 
  startDate: PropTypes.any.isRequired, 
  endDate: PropTypes.any.isRequired, 
  onClick: PropTypes.func.isRequired
};